import { render } from "./PackageDetailsPage.vue?vue&type=template&id=688abf96"
import script from "./PackageDetailsPage.vue?vue&type=script&lang=js"
export * from "./PackageDetailsPage.vue?vue&type=script&lang=js"

import "./PackageDetailsPage.vue?vue&type=style&index=0&id=688abf96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__